import { TSavedLaneSchema } from 'transfix-form/forms/SavedLaneForm/schema'
import {
  getSavedLaneSchemaDateType,
  getSavedLaneSchemaDaysOfWeek,
  getSavedLaneSchemaEquipment,
  getSavedLaneSchemaLane,
  getSavedLaneSchemaRateType,
} from 'transfix-form/forms/SavedLaneForm/utils'
import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'

/**
 * Generates a TSavedlaneObject from a LaneAlert object
 */
export const getMPSavedLaneSchema = (savedLane: LaneAlert): TSavedLaneSchema => {
  const {
    pickupIsoDaysOfWeek = [],
    pickupStartDate = '',
    rate,
    rateType,
    recipientSubscribers,
    trailerType,
  } = savedLane || {}

  return {
    lane: getSavedLaneSchemaLane(savedLane),
    dateType: getSavedLaneSchemaDateType({ pickupIsoDaysOfWeek, pickupStartDate }),
    equipment: getSavedLaneSchemaEquipment(trailerType),
    rateType: getSavedLaneSchemaRateType(rateType || null),
    rate: rate || null,
    daysOfWeek: getSavedLaneSchemaDaysOfWeek(pickupIsoDaysOfWeek),
    date: pickupStartDate || null,
    recipients: recipientSubscribers.map(
      ({ email, firstName, hasNotificationsEnabled, lastName, parentUserId }) => ({
        user: {
          id: `${parentUserId}`,
          text: `${firstName} ${lastName} · ${email}`,
          name: `${firstName} ${lastName}`,
          email: email || '',
        },
        receiveNotifications: hasNotificationsEnabled,
      })
    ),
    motorCarrierId: null, // This field is not used in MP
    receiveNotifications: false, // This field is not used in MP
  }
}
